import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const VUEX_PROPERTIES = ['state', 'getters', 'actions', 'mutations']

let store = {};

(function updateModules () {
  // If store is an exported method = classic mode (deprecated)

  if (typeof store === 'function') {
    return console.warn('Classic mode for store/ is deprecated and will be removed in Nuxt 3.')
  }

  // Enforce store modules
  store.modules = store.modules || {}

  resolveStoreModules(require('../store/auth.js'), 'auth.js')
  resolveStoreModules(require('../store/bonPlan.js'), 'bonPlan.js')
  resolveStoreModules(require('../store/categorie.js'), 'categorie.js')
  resolveStoreModules(require('../store/commande.js'), 'commande.js')
  resolveStoreModules(require('../store/compte.js'), 'compte.js')
  resolveStoreModules(require('../store/confirm.js'), 'confirm.js')
  resolveStoreModules(require('../store/coupon.js'), 'coupon.js')
  resolveStoreModules(require('../store/discussion.js'), 'discussion.js')
  resolveStoreModules(require('../store/enviemoment.js'), 'enviemoment.js')
  resolveStoreModules(require('../store/goal.js'), 'goal.js')
  resolveStoreModules(require('../store/historique.js'), 'historique.js')
  resolveStoreModules(require('../store/institut.js'), 'institut.js')
  resolveStoreModules(require('../store/item.js'), 'item.js')
  resolveStoreModules(require('../store/livraison.js'), 'livraison.js')
  resolveStoreModules(require('../store/marque.js'), 'marque.js')
  resolveStoreModules(require('../store/panneau.js'), 'panneau.js')
  resolveStoreModules(require('../store/points.js'), 'points.js')
  resolveStoreModules(require('../store/praticienne.js'), 'praticienne.js')
  resolveStoreModules(require('../store/pre_inscription.js'), 'pre_inscription.js')
  resolveStoreModules(require('../store/prestation.js'), 'prestation.js')
  resolveStoreModules(require('../store/produit.js'), 'produit.js')
  resolveStoreModules(require('../store/retours.js'), 'retours.js')
  resolveStoreModules(require('../store/salon.js'), 'salon.js')
  resolveStoreModules(require('../store/statistique.js'), 'statistique.js')
  resolveStoreModules(require('../store/stores.js'), 'stores.js')
  resolveStoreModules(require('../store/tag.js'), 'tag.js')
  resolveStoreModules(require('../store/theme.js'), 'theme.js')
  resolveStoreModules(require('../store/user.js'), 'user.js')

  // If the environment supports hot reloading...

  if (process.client && module.hot) {
    // Whenever any Vuex module is updated...
    module.hot.accept([
      '../store/auth.js',
      '../store/bonPlan.js',
      '../store/categorie.js',
      '../store/commande.js',
      '../store/compte.js',
      '../store/confirm.js',
      '../store/coupon.js',
      '../store/discussion.js',
      '../store/enviemoment.js',
      '../store/goal.js',
      '../store/historique.js',
      '../store/institut.js',
      '../store/item.js',
      '../store/livraison.js',
      '../store/marque.js',
      '../store/panneau.js',
      '../store/points.js',
      '../store/praticienne.js',
      '../store/pre_inscription.js',
      '../store/prestation.js',
      '../store/produit.js',
      '../store/retours.js',
      '../store/salon.js',
      '../store/statistique.js',
      '../store/stores.js',
      '../store/tag.js',
      '../store/theme.js',
      '../store/user.js',
    ], () => {
      // Update `root.modules` with the latest definitions.
      updateModules()
      // Trigger a hot update in the store.
      window.$nuxt.$store.hotUpdate(store)
    })
  }
})()

// createStore
export const createStore = store instanceof Function ? store : () => {
  return new Vuex.Store(Object.assign({
    strict: (process.env.NODE_ENV !== 'production')
  }, store))
}

function normalizeRoot (moduleData, filePath) {
  moduleData = moduleData.default || moduleData

  if (moduleData.commit) {
    throw new Error(`[nuxt] ${filePath} should export a method that returns a Vuex instance.`)
  }

  if (typeof moduleData !== 'function') {
    // Avoid TypeError: setting a property that has only a getter when overwriting top level keys
    moduleData = Object.assign({}, moduleData)
  }
  return normalizeModule(moduleData, filePath)
}

function normalizeModule (moduleData, filePath) {
  if (moduleData.state && typeof moduleData.state !== 'function') {
    console.warn(`'state' should be a method that returns an object in ${filePath}`)

    const state = Object.assign({}, moduleData.state)
    // Avoid TypeError: setting a property that has only a getter when overwriting top level keys
    moduleData = Object.assign({}, moduleData, { state: () => state })
  }
  return moduleData
}

function resolveStoreModules (moduleData, filename) {
  moduleData = moduleData.default || moduleData
  // Remove store src + extension (./foo/index.js -> foo/index)
  const namespace = filename.replace(/\.(js|mjs)$/, '')
  const namespaces = namespace.split('/')
  let moduleName = namespaces[namespaces.length - 1]
  const filePath = `store/${filename}`

  moduleData = moduleName === 'state'
    ? normalizeState(moduleData, filePath)
    : normalizeModule(moduleData, filePath)

  // If src is a known Vuex property
  if (VUEX_PROPERTIES.includes(moduleName)) {
    const property = moduleName
    const propertyStoreModule = getStoreModule(store, namespaces, { isProperty: true })

    // Replace state since it's a function
    mergeProperty(propertyStoreModule, moduleData, property)
    return
  }

  // If file is foo/index.js, it should be saved as foo
  const isIndexModule = (moduleName === 'index')
  if (isIndexModule) {
    namespaces.pop()
    moduleName = namespaces[namespaces.length - 1]
  }

  const storeModule = getStoreModule(store, namespaces)

  for (const property of VUEX_PROPERTIES) {
    mergeProperty(storeModule, moduleData[property], property)
  }

  if (moduleData.namespaced === false) {
    delete storeModule.namespaced
  }
}

function normalizeState (moduleData, filePath) {
  if (typeof moduleData !== 'function') {
    console.warn(`${filePath} should export a method that returns an object`)
    const state = Object.assign({}, moduleData)
    return () => state
  }
  return normalizeModule(moduleData, filePath)
}

function getStoreModule (storeModule, namespaces, { isProperty = false } = {}) {
  // If ./mutations.js
  if (!namespaces.length || (isProperty && namespaces.length === 1)) {
    return storeModule
  }

  const namespace = namespaces.shift()

  storeModule.modules[namespace] = storeModule.modules[namespace] || {}
  storeModule.modules[namespace].namespaced = true
  storeModule.modules[namespace].modules = storeModule.modules[namespace].modules || {}

  return getStoreModule(storeModule.modules[namespace], namespaces, { isProperty })
}

function mergeProperty (storeModule, moduleData, property) {
  if (!moduleData) {
    return
  }

  if (property === 'state') {
    storeModule.state = moduleData || storeModule.state
  } else {
    storeModule[property] = Object.assign({}, storeModule[property], moduleData)
  }
}
